<h1 mat-dialog-title>Temperatura</h1>
<div mat-dialog-content>
  <div class="modal-body text-center">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()" [appUppercaseForm]="this.setUppercaseText">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Temperatura</mat-label>
            <input [value]="data.discriminatorsValues[this.discriminatorType]" [mask]="masks.temperature"
              type="text" matInput formControlName="temperature">
              <span matSuffix>ºC</span>
            </mat-form-field>
          </div>
        </div>
        @if (data.classificationData.priorityAutistic && !data.discriminatorsValues[this.discriminatorType]) {
          <div
            class="row">
            <div class="col-12">
              <mat-slide-toggle class="priorityAutistic" (change)="changePriorityAutistic($event)"
                formControlName="priorityAutistic">
                Não é possível aferir
              </mat-slide-toggle>
            </div>
            @if (autisticChecked) {
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>Motivo</mat-label>
                  <textarea type="text" matInput formControlName="discriminatorSelectionMotive"></textarea>
                </mat-form-field>
              </div>
            }
          </div>
        }
        <div class="footer-panel-modal-list">
          <div class="row">
            <div class="col-12">
              <button type="submit" mat-flat-button color="primary" class="btn-block">Concluir</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>